

































































import Vue from "vue";
import Component from "vue-class-component";
import QNotify from "@/common/qNotify";
import QErrors from "@/common/qErrors.vue";
import { AuthService } from "@/common/api";
import qNotify from "@/common/qNotify";
import { compareWithKeys } from "@/common/utils";
import EditPassword from "@/sites/admin/pages/editPassword.vue";
import { namespace } from "vuex-class";
import User from "@/model/user";

const auth = namespace("Auth");
@Component({
  name: "EditProfile",
  components: {
    QErrors,
    EditPassword,
  },
})
export default class EditProfile extends Vue {
  @auth.Getter
  isAdmin!: boolean;

  @auth.Getter
  getLoggingUser: User;

  @auth.Action
  setUser!: (user) => void;

  public isShow = false;
  public errors = {};
  public errorStyle = {
    maxWidth: "100%",
  };
  public initForm = null;

  public form = {
    userId: null,
    name: "",
    email: "",
  };

  public option = [];

  mounted() {
    this.setInitForm();
    this.clearForm();
  }

  public setInitForm() {
    this.initForm = {
      userId: this.getLoggingUser.id,
      name: this.getLoggingUser.name,
      email: this.getLoggingUser.email,
    };
  }

  public clearForm() {
    this.form = { ...this.initForm };
  }

  public show() {
    this.clearForm();
    this.errors = {};
    this.isShow = true;
  }

  async save() {
    this.errors = {};
    let result;
    try {
      result = await AuthService.authUpdate(this.form);
      this.setUser(result.data.user);
      this.setInitForm();
    } catch (error) {
      result = error;
    }

    if (result.status == "success") {
      qNotify.success({
        text: this.$t("common.message.updated"),
      });
      this.isShow = false;
      this.$emit("close");
    } else if (result.status == "400") {
      this.errors = result.body.errors;
    } else {
      QNotify.error({
        text: result.body.message,
      });
    }
  }

  public cancel() {
    if (this.isChanged()) {
      this.$modal.showCancel({
        text: `${this.$t("common.modal.cancel_content")}`,
        confirmText: `${this.$t("common.buttons.yes")}`,
        cancelText: `${this.$t("common.buttons.no")}`,
        onConfirm: () => {
          this.isShow = false;
        },
      });
    } else {
      this.isShow = false;
    }
  }

  public isChanged() {
    return !compareWithKeys(this.form, this.initForm, ["name", "email"]);
  }

  public editPassword() {
    if (this.isChanged()) {
      this.$modal.showCancel({
        text: `${this.$t("common.modal.reset_profile")}`,
        confirmText: `${this.$t("common.buttons.yes")}`,
        cancelText: `${this.$t("common.buttons.no")}`,
        onConfirm: () => {
          (this.$refs.editPassword as EditPassword).show();
          this.isShow = false;
        },
      });
    } else {
      (this.$refs.editPassword as EditPassword).show();
      this.isShow = false;
    }
  }
}
